import { SmartLink } from "@selector/shared/components";
import type { FC } from "react";

import { JobAdminType } from "@/graphql.js";
import type { JobAdminListingFragment } from "@/ui-modules/admin/graphql/job-admin-queries.gql.ts";

import type { IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const JobTitleCell: FC<IAgGridCellProps> = (props) => {
  const jobAdmin = props.data.job as JobAdminListingFragment;

  if (jobAdmin == null) {
    return null;
  }

  return (
    <TableCell>
      {jobAdmin.type === JobAdminType.PlaybookEvent ? (
        <SmartLink to={`/event/${jobAdmin.id}`} tooltip={"Go to the corresponding event summary page"}>
          {props.value}
        </SmartLink>
      ) : (
        <SmartLink to={`/processor/session/${jobAdmin.id}`} tooltip={"Go to the corresponding Processor session"}>
          {props.value}
        </SmartLink>
      )}
    </TableCell>
  );
};

export default JobTitleCell;
